const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQMentis1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "250px",
    height: "250px",
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,58.823532%,100%)",
      fillOpacity: 1
    },
    d: "M 180.886719 176.191406 C 193.246094 162.707031 200.789062 144.734375 200.789062 125 C 200.789062 83.144531 166.855469 49.210938 125 49.210938 C 83.144531 49.210938 49.210938 83.144531 49.210938 125 C 49.210938 166.855469 83.144531 200.789062 125 200.789062 C 144.996094 200.789062 163.1875 193.042969 176.730469 180.386719 L 141.546875 145.722656 C 140.386719 144.578125 140.371094 142.707031 141.515625 141.546875 C 142.660156 140.386719 144.53125 140.371094 145.691406 141.515625 Z M 125.097656 100.746094 C 125.558594 108.101562 131.222656 123.269531 149.960938 125.113281 C 141.988281 126.175781 125.816406 132.632812 125.097656 149.960938 C 125.234375 142.289062 120.597656 126.582031 100.746094 125.113281 C 108.3125 124.796875 123.726562 119.476562 125.097656 100.746094 Z M 167.316406 94.761719 C 158.320312 93.875 155.886719 86.59375 155.664062 83.0625 C 155.007812 92.054688 147.324219 94.609375 143.695312 94.761719 C 153.222656 95.464844 155.730469 103.003906 155.664062 106.6875 C 156.007812 98.367188 163.488281 95.269531 167.316406 94.761719 Z M 167.316406 94.761719 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQMentis1);
export default __webpack_public_path__ + "static/media/QMentis1.7cae30a28df31d0b16282b299d0de7b2.svg";
export { ForwardRef as ReactComponent };